import React, { createContext, useContext, useState } from 'react';

export const createModalState = ({ stateContextName, dispatchContextName }) => {
  const StateContext = createContext();
  const DispatchContext = createContext();

  StateContext.displayName = stateContextName;
  DispatchContext.displayName = dispatchContextName;

  const Provider = ({ children }) => {
    const [state, setState] = useState(null);

    return (
      <StateContext.Provider value={state}>
        <DispatchContext.Provider value={setState}>
          {children}
        </DispatchContext.Provider>
      </StateContext.Provider>
    );
  };

  const useModalState = () => {
    const context = useContext(StateContext);

    if (context === undefined) {
      throw new Error('Нет провайдера');
    }

    return context;
  };

  const useModalDispatch = () => {
    const context = useContext(DispatchContext);
    if (context === undefined) {
      throw new Error('Нет провайдера');
    }
    return context;
  };

  return {
    Provider,
    useModalState,
    useModalDispatch,
  };
};
